var AbsoluteShowingQueueSupport = require("enyo-perf/AbsoluteShowingQueueSupport"),
    FadeSupport                 = require("enyo-ui/FadeSupport"),
    Scrim                       = require("enyo-ui/Scrim"),
    Spinner                     = require("app/ui/Spinner"),
    frameThrottle               = require("enyo-perf/utils").frameThrottle,
    kind                        = require("enyo/kind"),
    logger                      = require("enyo/logger");

module.exports = kind(/** @lends  app.MediaPlayer.AbstractPlayerView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.AbstractPlayerView",

    /**
     * @private
     */
    mixins: [AbsoluteShowingQueueSupport],

    /**
     * The state of the media player.
     *
     * @type  {?Object}
     * @private
     */
    state: null,

    /**
     * The kind of media player used.
     *
     * @type  {enyo.Control}
     * @public
     */
    playerKind: null,

    /**
     * @private
     */
    loaderComponents: [{
        name:               "innerScrim",
        kind:               Scrim,
        floating:           false,
        classes:            "app-media-player-player-view__inner-scrim app-ui-scrim",
        showing:            false,
        initialOpacity:     0,
        usePerformanceMode: true
    }, {
        name:               "spinner",
        kind:               Spinner,
        classes:            "app-media-player-player-view__spinner",
        mixins:             [FadeSupport],
        showing:            false,
        initialOpacity:     0,
        usePerformanceMode: true
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".state",
        to:   ".$.player.state"
    }, {
        from: ".$.player.isPlaying",
        to:   "isPlaying"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.createComponents(this.loaderComponents);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update                         = frameThrottle(this.bindSafely(this.update));
            this.lazyResize                     = frameThrottle(this.bindSafely(this.resize));
            this.updateLoadingGraphicVisibility = this.bindSafely(this.updateLoadingGraphicVisibility);
            sup.apply(this, arguments);
            this.observe("controller.loadingGraphicRequests", this.updateLoadingGraphicVisibility);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("controller.displayMode", this.lazyResize);
            this.updateLoadingGraphicVisibility();
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var errorMsg = "app.MediaPlayer.AbstractPlayerView.update() not implemented";

        logger.warn();

        if (typeof Sentry !== "undefined") {
            Sentry.captureException(new Error(errorMsg));
        }
    },

    /**
     * Verify displayMode support
     *
     * @param    {string}   displayMode  The display mode
     * @returns  {boolean}  Whether the display mode is supported
     * @public
     */
    supportsDisplayMode: function() {
        var errorMsg = "app.MediaPlayer.AbstractPlayerView.supportsDisplayMode() not implemented";

        logger.warn();

        if (typeof Sentry !== "undefined") {
            Sentry.captureException(new Error(errorMsg));
        }

        return false;
    },

    // Player Tech
    // --------------------------------

    /**
     * Mounts the player tech in the player view.
     *
     * @param  {enyo.Control}  playerTech  The player tech
     * @public
     */
    mountPlayerTech: function(playerTech) {
        this.mountView(playerTech);
        this.resize();
    },

    /**
     * Unmounts the player tech in the player view.
     *
     * @param  {enyo.Control}  playerTech  The player tech
     * @public
     */
    unmountPlayerTech: function(playerTech) {
        this.unmountView(playerTech);
        this.resize();
    },

    /**
     * Get the mounted player tech.
     *
     * @returns  {?enyo.Control}  The player tech instance if available, `null`
     *                            otherwise.
     * @public
     */
    getPlayerTech: function() {
        return this.view || null;
    },

    // Loading Graphic Visibility
    // --------------------------------

    /**
     * Shows the loading graphic if it was requested at least once on the
     * MediaPlayerController. Hides the loading graphic again once all previous
     * requests have been withdrawn.
     *
     * @private
     */
    updateLoadingGraphicVisibility: function() {
        var currentCount = this.controller.loadingGraphicRequests,
            innerScrim   = this.$.innerScrim,
            spinner      = this.$.spinner;

        if (currentCount > 0) {
            if (!innerScrim.get("showing") || innerScrim.get("willHide")) {
                innerScrim.requestShow(true, false);
            }
            spinner.show(true, false);
        }

        if (currentCount === 0) {
            if (innerScrim.get("showing") || innerScrim.get("willShow")) {
                innerScrim.requestHide(true, false);
            }
            spinner.hide(true, false);
        }
    }
});
